import { useEffect, useState } from 'react';

// true from the sm width (640 px) of Tailwind. The BI header (D24 of the Property comparison) puts "Reservations as of" into the
// one-line sublabel of the title only when there is room; on a phone it gets its own line under the title.
const QUERY = '(min-width: 640px)';

const useWideScreen = (): boolean => {
	const [wide, setWide] = useState(() => window.matchMedia(QUERY).matches);
	useEffect(() => {
		const media = window.matchMedia(QUERY);
		const onChange = () => setWide(media.matches);
		media.addEventListener('change', onChange);
		return () => media.removeEventListener('change', onChange);
	}, []);
	return wide;
};

export default useWideScreen;
